import _Message from "@arco-design/web-react/es/Message";
import { useMemo } from 'react';
import { useLocation } from 'react-router';
import useLocale from './useLocale';
function useQuery() {
  var search = useLocation().search;
  return useMemo(function () {
    return new URLSearchParams(search);
  }, [search]);
}
function usePreviewVersion() {
  var t = useLocale({
    'en-US': {
      previewMsg: 'Currently in preview mode, please switch back to the latest version first'
    },
    'zh-CN': {
      previewMsg: '当前处于预览模式，请先切回最新版本'
    }
  }).t;
  var query = useQuery();
  var currentPreviewVersion = query.get('previewVersion') || '';
  var isPreview = Boolean(currentPreviewVersion);
  var previewHint = function previewHint(msg) {
    _Message.warning(msg || t['previewMsg']);
  };
  return {
    isPreview: isPreview,
    currentPreviewVersion: currentPreviewVersion,
    previewMsg: t['previewMsg'],
    previewHint: previewHint
  };
}
export default usePreviewVersion;